import { Injectable } from "@angular/core";
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from "angularfire2/database";
import { Product, optionGroup } from "../models/product";
import { AuthService } from "./auth.service";
import { ToastrService } from "./toastr.service";
import * as _ from "lodash";
import { OrderService } from "./order-service";

@Injectable()
export class ProductService {
  products: AngularFireList<Product>;
  product: AngularFireObject<Product>;
  toppings: AngularFireList<Product>;
  placeinfo: AngularFireList<Product>;
  // NavbarCounts
  navbarCartCount = 0;
  navbarFavProdCount = 0;

  constructor(
    private db: AngularFireDatabase,
    private orderService: OrderService,
  ) {
    this.calculateLocalCartProdCounts();
  }

  getPlaceInfo() {
    return this.db.object("placeinfo");
  }

  updatePlaceInfo(data) {
    this.db.object("placeinfo/").update(data);
  }

  getProducts() {
    this.products = this.db.list("products");
    return this.products;
  }

  getProductsObject() {
    return this.db.object("products");
  }

  getCategories() {
    return this.db.list("categories");
  }

  getCategoriesObject() {
    return this.db.object("categories");
  }
  getBranchesObject() {
    return this.db.object("branches");
  }
  getToppings() {
    return this.db.object("toppings");
  }

  getToppingGroup() {
    return this.db.list("toppingsGroup");
  }

  getToppingGroupObject() {
    return this.db.object("toppingsGroup");
  }

  changeProduct(product) {
    // this.db.database
    //     .ref("product").orderByChild('productId').equalTo(product.productId)
  }

  createProduct(data: Product) {
    this.db.list("products").push(data);
  }

  createTopping(data: Product) {
    this.db.list("toppings").push(data);
  }

  createCategory(data: Product) {
    this.db.list("categories").push(data);
  }

  createToppingGroup(data: optionGroup) {
    this.db.list("toppingsGroup").push(data);
  }

  getProductById(key: string) {
    this.product = this.db.object("products/" + key);
    return this.product;
  }

  updateProducts(data, key) {
    this.db.object("products/" + key).update(data);
  }

  updateCategory(data, key) {
    this.db.object("categories/" + key).update(data);
  }

  updateBranch(data, key) {
    this.db.object("branches/" + key).update(data);
  }

  updateTopping(data, key) {
    this.db.object("toppings/" + key).update(data);
  }

  updateToppingGroup(data) {
    const key = data.$key;
    delete data.$key;
    this.db.object("toppingsGroup/" + key).update(data);
  }

  addToppingToGroup(data: Product, key) {
    this.db.list("toppingsGroup/" + key + "/toppings").push(data);
  }

  addToppingGroupToProduct(data: Product, key) {
    this.db.list("products/" + key + "/toppings").push(data);
  }

  deleteToppingGroupToProduct(data: Product, key) {
    this.db.list("products/" + key + "/toppings/" + data["key"]).remove();
  }

  deleteToppingToGroup(data: Product, key) {
    this.db.list("toppingsGroup/" + key + "/toppings/" + data["key"]).remove();
  }

  deleteProduct(key: string) {
    this.products.remove(key);
  }

  addToCart(data: Product): void {
    let items: Product[];
    items = this.orderService.getOrderItems() || [];
    items.push(data);
    this.orderService.setOrder({ items: items });
    // this.toastrService.wait("הוספת פריט", "פריט הוסף בהצלחה");
    // localStorage.setItem("avct_item", JSON.stringify(items));
    // this.calculateLocalCartProdCounts();
  }

  removeLocalCartProduct(product: Product) {
    const items: Product[] = this.orderService.getOrderItems();

    for (let i = 0; i < items.length; i++) {
      if (items[i].productId === product.productId) {
        items.splice(i, 1);
        break;
      }
    }
    this.orderService.setOrder({ items: items });
  }

  removeCart() {
    this.orderService.setOrder({ items: [] });
  }

  // Fetching Locat CartsProducts
  getLocalCartProducts(): Product[] {
    const products: Product[] =
      JSON.parse(localStorage.getItem("avct_item")) || [];
    return products;
  }

  public calculateLocalCartProdCounts() {
    return this.orderService.getOrderItems().length;
  }

}
